import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
export function SplashScreen() {
  const {
    resetTo
  } = useNavigation();
  useEffect(() => {
    const timer = setTimeout(() => {
      resetTo(Screen.ONBOARDING);
    }, 2000);
    return () => clearTimeout(timer);
  }, [resetTo]);
  return <div className="flex flex-col items-center justify-center min-h-screen bg-primary" data-id="element-1454">
      <motion.div initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} className="flex flex-col items-center" data-id="element-1455">
        <img src="https://cdn.magicpatterns.com/uploads/qwjBm9dydTfJXkZFWZ9RtX/JUMMALL_UPDATED_LOGO_(1).png" alt="JUMMALL Logo" className="w-64 h-auto object-contain mb-6" data-id="element-1456" />
      </motion.div>

      <motion.div className="absolute bottom-16" animate={{
      opacity: [0.5, 1, 0.5]
    }} transition={{
      duration: 1.5,
      repeat: Infinity
    }} data-id="element-1457">
        <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin" data-id="element-1458" />
      </motion.div>
    </div>;
}